"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usdToCurrency = exports.CONVERSION_DIFF = void 0;
const pricing_1 = require("../consts/pricing");
const DEFAULT_CONVERSION_DIFF = 1.3;
// This is the added calculation for the difference of the shipment between countries and the US
exports.CONVERSION_DIFF = {
    CAD: 1.11,
    GBP: 1.095,
    EUR: 1.095,
    ILS: 1.05,
    USD: 1
};
/**
 * Converts a price in USD to the given currency, plus a difference factor that takes different shipping costs into account.
 * @param usd
 * @param currency
 * @return {number}
 */
function usdToCurrency(usd, currency) {
    const usdPrice = usd * pricing_1.CURRENCY_CONVERSIONS[currency];
    const conversionDiff = exports.CONVERSION_DIFF[currency] || DEFAULT_CONVERSION_DIFF;
    return Math.round(usdPrice * conversionDiff);
}
exports.usdToCurrency = usdToCurrency;
//# sourceMappingURL=usdToCurrency.js.map